/* eslint-disable react-hooks/exhaustive-deps */
/* ============================================================
   จัดการข้อความมาตรฐาน/กฎหมายสารก่อภูมิแพ้ (Allergenic)

   เพิ่ม / แก้ไข / ลบ ได้เอง เวลากฎหมายเปลี่ยนก็มาแก้ที่นี่ที่เดียว
   แล้วทุกเอกสารจะเลือกจาก dropdown ได้เลย
============================================================ */
import { useEffect, useState } from "react";
import { Modal, Table, Input, Button, Space, Flex, Popconfirm, message } from "antd";
import { PlusOutlined, EditOutlined } from "@ant-design/icons";
import { RiDeleteBin5Line } from "react-icons/ri";

import AllergenStandardService from "../../../service/AllergenStandard.service";

const service = AllergenStandardService();

export default function ModalAllergenStandard({ show, close, onChanged, defaultText = "" }) {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [editing, setEditing] = useState(null);

  const load = () => {
    setLoading(true);
    service
      .list()
      .then((res) => setRows(res.data?.data || []))
      .catch(() => message.error("โหลดรายการไม่สำเร็จ"))
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (show) {
      setName(defaultText || "");
      setEditing(null);
      load();
    }
  }, [show]);

  const handleSave = () => {
    const v = (name || "").trim();
    if (!v) {
      message.error("กรุณากรอกข้อความ");
      return;
    }
    const req = editing ? service.update(editing.id, v) : service.create(v);
    req
      .then((res) => {
        message.success(res.data?.message || "บันทึกเรียบร้อย");
        setName("");
        setEditing(null);
        load();
        if (typeof onChanged === "function") onChanged();
      })
      .catch((err) =>
        message.error(err?.response?.data?.message || "บันทึกไม่สำเร็จ")
      );
  };

  const handleDelete = (rec) => {
    service
      .deleted(rec.id)
      .then(() => {
        message.success("ลบเรียบร้อย");
        load();
        if (typeof onChanged === "function") onChanged();
      })
      .catch((err) => message.error(err?.response?.data?.message || "ลบไม่สำเร็จ"));
  };

  return (
    <Modal
      title="จัดการข้อความมาตรฐาน / กฎหมาย (Allergenic)"
      open={show}
      onCancel={() => close(false)}
      footer={null}
      width={760}
      destroyOnClose
    >
      <Space direction="vertical" style={{ display: "flex" }} size="middle">
        <Flex gap={8} align="start">
          <Input.TextArea
            rows={2}
            placeholder="เช่น According to CODEX STAN 1-1985, ..."
            value={name}
            onChange={(e) => setName(e.target.value)}
          />
          <Space direction="vertical">
            <Button type="primary" icon={<PlusOutlined />} onClick={handleSave}>
              {editing ? "บันทึก" : "เพิ่ม"}
            </Button>
            {editing && (
              <Button
                onClick={() => {
                  setEditing(null);
                  setName("");
                }}
              >
                ยกเลิก
              </Button>
            )}
          </Space>
        </Flex>

        <Table
          size="small"
          bordered
          rowKey="id"
          loading={loading}
          dataSource={rows}
          pagination={{ pageSize: 8, showSizeChanger: false }}
          locale={{ emptyText: <span>ยังไม่มีข้อความในระบบ</span> }}
          columns={[
            { title: "ข้อความมาตรฐาน / กฎหมาย", dataIndex: "name" },
            {
              title: "",
              key: "action",
              width: 100,
              align: "center",
              render: (_, rec) => (
                <Space size={4}>
                  <Button
                    size="small"
                    icon={<EditOutlined />}
                    onClick={() => {
                      setEditing(rec);
                      setName(rec.name);
                    }}
                  />
                  <Popconfirm
                    title="ลบข้อความนี้?"
                    okText="ลบ"
                    cancelText="ยกเลิก"
                    onConfirm={() => handleDelete(rec)}
                  >
                    <Button size="small" danger icon={<RiDeleteBin5Line />} />
                  </Popconfirm>
                </Space>
              ),
            },
          ]}
        />
      </Space>
    </Modal>
  );
}
